module.exports = __webpack_public_path__ + "img/approveCPL.c3331b21.svg";